export default __webpack_public_path__ + "static/media/myAlgoWallet.32e058bc.png";